export function formatTimestamp(timestamp: number): string {
  const date = new Date(timestamp * 1000);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Local time in ISO-like format
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatTimeAgo(timestamp: number): string {
  const seconds = Math.floor(Date.now() / 1000 - timestamp);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function formatNumber(num: number | null | undefined): string {
  if (num == null || Number.isNaN(num as number)) {
    return '0';
  }
  return (num as number).toLocaleString();
}

export function truncateHash(hash: string, start = 8, end = 8): string {
  if (hash.length <= start + end) return hash;
  return `${hash.slice(0, start)}...${hash.slice(-end)}`;
}

export function formatBlockTimeDelta(seconds: number | null): string {
  if (seconds === null) return 'N/A';
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}m ${secs}s`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(2)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(2)} MB`;
}

/**
 * Convert hex string to UTF-8 string
 * Based on mempool.space's hex2ascii pipe implementation
 * Handles scriptpubkey_asm format (extracts hex after OP_PUSH opcodes)
 */
export function hex2ascii(input: string): string {
  let hex = input;

  // If input looks like scriptpubkey_asm (contains OP_ codes), extract hex after OP_PUSH
  if (input.includes('OP_')) {
    const parts = input.split(' ');
    const opPush = parts.filter((_part, i, arr) => i > 0 && /^OP_PUSH/.test(arr[i - 1]));
    if (opPush[0]) {
      hex = opPush[0];
    }
  }

  if (!hex) {
    return '';
  }

  // Convert hex to bytes
  const bytes: number[] = [];
  for (let i = 0; i < hex.length; i += 2) {
    bytes.push(parseInt(hex.substr(i, 2), 16));
  }

  // Decode as UTF-8 and remove replacement chars and null bytes
  try {
    const decoded = new TextDecoder('utf-8').decode(Uint8Array.from(bytes));
    return decoded.replace(/\uFFFD/g, '').replace(/\0/g, '');
  } catch {
    return '';
  }
}
